<div mat-dialog-title>
	<button type="button" mat-icon-button class="close-button" (click)="evtCancel()">
			<mat-icon color="accent" svgIcon="close"></mat-icon>
	</button>
	
	<div class="error-label">{{dialogError}}</div>
</div>